export const AgruparConsolidado = (miArray) => {
    var array = miArray.reduce((groups, item) => {
      var val = item["concepto"];
      groups[val] = groups[val] || {
        concepto: val,
        invactual: 0,
        invanterior: 0,
        dias: 0,
        diasant: 0,
      };
      groups[val].invactual += Number(item.invactual);
      groups[val].invanterior += Number(item.invanterior);
      groups[val].dias += Number(item.dias);
      groups[val].diasant += Number(item.diasant);
      return groups;
    }, {});
  
    return Object.values(array);
  };
  
  export const NivelInventarioDias = (data, concepto) => {
    var dias = 0;
    var dividendo = 0;
  
    data.forEach((item) => {
      if (item.concepto === concepto) {
        dias += item.dias;
        if (item.dias > 0) dividendo++;
      }
    });
  
    if (dividendo > 0) {
      dias = dias / dividendo;
    }
  
    return dias;
  };
  export const NivelInventarioDiasAnt = (data, concepto) => {
      var dias = 0;
      var dividendo = 0;
    
      data.forEach((item) => {
        if (item.concepto === concepto) {
          dias += item.diasant;
          if (item.diasant > 0) dividendo++;
        }
      });
    
      if (dividendo > 0) {
        dias = dias / dividendo;
      }
    
      return dias;
    };
  
  export const Agrupar = (miArray, prop) => {
    var array = miArray.reduce((groups, item) => {
      var val = item[prop];
      groups[val] = groups[val] || val;
      return groups;
    }, {});
    return Object.values(array);
  };
  
  export const TotalizarByProp = (miArray, prop, value, sum) => {
    var total = 0;
    miArray.forEach((item) => {
      if (item[prop] === value) total += Number(item[sum]);
    });
    return total;
  };
  